import {
  EntityIconBase,
  type EntityIconAppearance,
  type EntityIconDensity,
} from './entity-icon-base';
import { Shapes01Icon } from '@terra/ui-icons';

type IconAssetProps = {
  appearance?: EntityIconAppearance;
  density?: EntityIconDensity;
};

export function IconAsset({ appearance, density }: IconAssetProps) {
  return (
    <EntityIconBase
      icon={Shapes01Icon}
      bg="bg.entity.assets"
      color="fg.entity.assets"
      borderColor="border.entity.assets"
      appearance={appearance}
      density={density}
    />
  );
}
